import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol.js";
import Point from "@arcgis/core/geometry/Point.js";

/**
 * Gets the incidents from an RFS endpoint and sends the response data to a 
 * callback function.
 * @param {*} graphicsCallback The callback function. This accepts two parameters,
 *  `newSymbol` and `geometryPoint` (in that order). This should be handed to some
 *  function to write these graphics to the map. 
 */
export function getIncidents(graphicsCallback) {
    $.ajax({
        url: "https://utility.arcgis.com/sharing/rss?url=http://www.rfs.nsw.gov.au/feeds/majorIncidents.xml&outSR=",
        method: "GET",
        dataType: "json",
        success: function(response) {
            // Response is already parsed as JSON if the server returned JSON
            response['featureCollection']['layers'].map(function(layer) {
                if(layer['name'] === 'Points') {
                    layer['featureSet']['features'].map(function(feature) {
                        // Determine what icon this should correspond to
                        const incidentCategory = feature['attributes']['category'];
                        let iconUrl;
                        switch(incidentCategory) {
                            case 'Advice':
                                iconUrl = 'img/dispatch/Advice.png'
                                break;
                            case 'Planned Burn':
                                iconUrl = 'img/dispatch/FireIncidentConfirmed.png'
                                break;
                            case 'Not Applicable':
                                iconUrl = 'img/dispatch/NotApplicable.png'
                                break;
                            case 'Emergency Warning':
                                iconUrl = 'img/dispatch/Emergency_Warning.png'
                                break;
                            default: 
                                // If you see this icon, then that means we've got an unhandled case
                                iconUrl = 'img/dispatch/AAHS_FIRE_INCIDENT_BLUE.png'
                                console.error(`Unknown incident category : ${incidentCategory}`)
                        }
                        
                        let incidentStatus = "";
                        try {
                            //Pulls the value of Status from the description field
                            incidentStatus = feature['attributes']['description'].split('<br />')[3].split(': ')[1].trim();
                        }
                        catch (error) {
                            console.log(error)
                        }
                        //The Responding icon is controlled by the status field and needs to be checked separately
                        if (incidentStatus == "Responding") {
                            //iconUrl = 'img/dispatch/FireAppliance.png';
                            iconUrl = 'img/dispatch/Responding.png';
                        }

                        const geometryPoint = new Point({
                            x: feature['geometry']['x'],
                            y: feature['geometry']['y']
                        })

                        // Create the icon
                        const newSymbol = new PictureMarkerSymbol({
                            url: iconUrl,
                            width: "30px",
                            height: "30px",
                        });
                        
                        graphicsCallback(newSymbol, geometryPoint, feature['attributes']);
                    })
                }
            });
        },
        error: function(xhr, status, error) {
            console.error("Error:", error);
            // Handle error here
        }
    });
}